import React, { useEffect } from 'react'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next';
import useTitle from 'hooks/useTitle';
import { useQuery } from '@tanstack/react-query';
import Service from 'Service';
import LoadingSpinner from 'Components/LoadingSpinner';
import InvoiceWizard from './invoice-wizard';
import useStores from 'hooks/useStores';
import uiStore from 'stores/uiStore';
const InvoiceEdit = () => {
    const { t } = useTranslation();
    const { invoicesStore, providersStore } = useStores()
    const { id } = useParams<{ id: string }>()
    const history = useHistory()
    const location = useLocation()

    const returnTo = React.useMemo(() => {
        const params = new URLSearchParams(location.search)
        return params.get('returnTo') || ''
    }, [location.search])

    const { data, isLoading } = useQuery({
        queryFn: async () => Service.DocumentCompletes.getSingle(id!),
        queryKey: ["INVOICES", "GET_INVOICE_BY_ID", id],
        enabled: Boolean(id),
    })

    const providerId = data?.Invoice?.IdProvider

    const { data: provider, isLoading: isLoadingProvider } = useQuery({
        queryKey: ["PROVIDERS", "GET_BY_ID", providerId],
        queryFn: async () => Service.Providers.getById(providerId!),
        enabled: Boolean(providerId),
    })

    useTitle('editing_invoice')

    useEffect(() => {
        if (provider) {
            providersStore.initProcess(provider, true)
        }
    }, [provider, providersStore])

    async function sendData() {
        await invoicesStore.updateCompleteDocument(id!)
        uiStore.notifySuccess(t('invoice_updated_successfully', { defaultValue: 'Factura actualizada correctamente' }))
        if (returnTo && returnTo.startsWith('/')) {
            history.push(returnTo)
        }
    }

    if (isLoading || (providerId && isLoadingProvider)) return <LoadingSpinner />

    if (!data) return <h3>{t('invoice_not_found')}</h3>;

    return (
        <InvoiceWizard
            title={t('editing_invoice')}
            editionMode={true}
            defaultInvoiceHeader={data.Invoice}
            defaultInvoiceDetails={data.InvoiceDetails}
            defaultProviderData={provider}
            onSendData={sendData} />
    )
}

export default InvoiceEdit
